<script>

    export default {
        data: () => ({
            CommonParam: false,
        }),
        methods: {
            //showLoading() {
            //    this.$store.commit('common_store/setLoading', true);
            //},
            //hideLoading() {
            //    this.$store.commit('common_store/setLoading', false);
            //},
            //setBreadcrumbItems(arr) {
            //    this.$store.commit('common_store/setBreadcrumbItems', arr);
            //},
            //setLoadingMessage(msg) {
            //    this.$store.commit('common_store/setLoadingMessage', msg);
            //},
            //readGetParams() {
            //    let queryString = window.location.search;
            //    const queryObject = {};
            //    if (queryString) {
            //        queryString = queryString.substring(1);
            //        const parameters = queryString.split('&');

            //        for (let i = 0; i < parameters.length; i++) {
            //            const element = parameters[i].split('=');

            //            const paramName = decodeURIComponent(element[0]);
            //            const paramValue = decodeURIComponent(element[1]);

            //            queryObject[paramName] = paramValue;
            //        }

            //        return queryObject;
            //    }

            //    return undefined;
            //},
            //setFunction(idx, text, callback) {
            //    this.$store.commit('common_store/setFunction', { idx, text, callback });
            //},
            //setDisableFunction(idx) {
            //    this.$store.commit('common_store/setDisableFunction', idx);
            //},
            //setDisableFunctionAll() {
            //    for (let i = 0; i < 13; i += 1) {
            //        this.$store.commit('common_store/setDisableFunction', i);
            //    }
            //},
            //numberFormat(value) {
            //    if (value === undefined) {
            //        return '';
            //    }
            //    if (value === null) {
            //        return '';
            //    }
            //    return Number(value).toLocaleString();
            //},
            //dateFormat(dt) {
            //    // 日付型をYYYY/MM/DD hh:mm:ssのYYYY/MM/DDのみを返す
            //    if (dt == null) {
            //        return '';
            //    }

            //    const ymd = dt.split(' ')[0];
            //    return ymd;
            //},
            //showPDF(file, base64) {
            //    let objbuilder = '';
            //    objbuilder += (`<object width="100%" height="100%" data="data:application/pdf;base64,${base64}`);
            //    objbuilder += ('" type="application/pdf" class="internal">');
            //    objbuilder += ('</object>');

            //    const win = window.open('about:blank', '_blank');
            //    const title = file;
            //    win.document.write(`<html><title>${title}</title><body style="margin: 0px; ">`);
            //    win.document.write(objbuilder);
            //    win.document.write('</body></html>');
            //},
            async downloadPDF(file, base64) {
                const blob = await (await fetch(`data:application/pdf;base64,${base64}`)).blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = file;
                link.click();
            },
            //async downloadZIP(file, base64) {
            //    const blob = await (await fetch(`data:application/zip;base64,${base64}`)).blob();
            //    const link = document.createElement('a');
            //    link.href = window.URL.createObjectURL(blob);
            //    link.download = file;
            //    link.click();
            //},
            //getMoment() {
            //    const m = moment();
            //    return m;
            //},
            //deepCopy(o) {
            //    return JSON.parse(JSON.stringify(o));
            //},
            //dispJson(value) {
            //    const result = JSON.stringify(value, null, '&emsp;').replace(/\n/g, '<br/>');
            //    return result;
            //},
            //sleep(callback, delay = 1000) {
            //    return new Promise((resolve) => {
            //        console.log('sleep');
            //        return setTimeout((res) => {
            //            callback();
            //            return resolve(res);
            //        }, delay);
            //    });
            //},
        },
    };</script>
